module.exports = __webpack_public_path__ + "img/new.152af95c.png";